import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createPO: [],
  loading: false,
  error: null,
};

const createPOSlice = createSlice({
  name: "createPO",
  initialState,
  reducers: {
    fetchCreatePORequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCreatePOSuccess: (state, action) => {
      state.loading = false;
      state.createPO = action.payload;
    },

    fetchCreatePOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCreatePORequest,
  fetchCreatePOSuccess,
  fetchCreatePOFailure,
} = createPOSlice.actions;

export default createPOSlice.reducer;